<template>
  <div id="helpContact" class="footer-info">
    <div class="grid-x center">
      <h3 class="need-help">Need Help?</h3>
      <h2 class="phone-number-need-help">{{ insuranceType.phone | phone }}</h2>
      <div class="schedule-need-help">
        <pretty-schedule v-if="insuranceType && insuranceType.hours" :schedule="insuranceType.hours" :schedule2="insuranceType.hours2" />
      </div>
      <div class="email-need-help">
        <a :href="`mailto:${this.insuranceType.email}`">{{ insuranceType.email }}</a>
      </div>
    </div>
  </div>
</template>

<script>
// Utils
import { mapState } from 'vuex';

// Components
import prettySchedule from '@/components/shared/pretty-schedule';

export default {
  name: 'help-contact',
  components: {
    prettySchedule
  },
  computed: {
    ...mapState(['insuranceType'])
  }
}
</script>

<style lang="scss">
@import '~@/styles/variables.scss';

.need-help, .phone-number-need-help {
  margin-bottom: 0;
}

.footer-info {
  flex: 1 0 auto;
  padding-bottom: 50px;
}

.phone-number-need-help {
  color: $sfi-header-primary-color;
}

.schedule-need-help {
  color: $black;
  font-size: 16px;
}

.email-need-help {
  color: $sfi-header-primary-color;
  font-size: 14px;
  margin-top: 8px;
  font-weight: 400;
}

</style>



// WEBPACK FOOTER //
// src/components/help-contact.vue